import React from "react";
import img1 from '../images/banner1.jpg';
import "../Components/banner.css"


function Bannerbanner() {
  return (
    <>
     <div>
        <img src={img1} alt="bannerimg"/>
     </div>

        
    </>
  );
}

export default Bannerbanner;